import { type ReactNode, Suspense } from 'react';

import { useMediaQuery, type Theme } from '@mui/material';

import { MarketingTextLazy } from '@/shared/text/marketingText/MarketingTextLazy';

import landing from '@/assets/img/landing.png';

import { useStyles } from './LoginWrapper.styles';

export const LoginWrapper = ({ children }: { children: ReactNode }) => {
  const classes = useStyles();
  const isNotOnMobile = useMediaQuery((theme: Theme) => theme.breakpoints.up('mobile'));

  return (
    <main className={classes.wrapper}>
      <div className={classes.leftSide}>{children}</div>
      {isNotOnMobile && (
        <div className={classes.rightSide}>
          <Suspense fallback={<div />}>
            <MarketingTextLazy label="landing.slogan" className={classes.marketingText} gradient />
            <img src={landing} alt="landing" className={classes.landingImage} loading="lazy" />
          </Suspense>
        </div>
      )}
    </main>
  );
};
